import * as React from 'react';
import Tab from '@mui/material/Tab';
import { styled } from '@mui/material/styles';

const IconCircle = styled('span')(({ iconBackground }) => ({
  width: 28,
  height: 28,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  background: iconBackground || 'var(--trashie-ui-lavander)',
  marginRight: 8,
}));

const StyledCategoryTab = styled((props) => {
  const { icon, label, iconBackground, ...rest } = props;
  return (
    <Tab
      disableRipple
      {...rest}
      icon={icon ? <IconCircle iconBackground={iconBackground}>{icon}</IconCircle> : null}
      label={label}
      iconPosition="start"
    />
  );
})(
  {

    textAlign: 'center',
    fontFamily: 'GT Maru',
    textTransform: 'none',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '100%',
    minHeight: 0,
    minWidth: 0,
    borderRadius: '20px',
    gap: '0.25rem',
    padding: '0.25rem 0.5rem 0.25rem 0.25rem',
    display: 'flex',
    alignItems: 'center',
    background: 'var(--trashie-ui-gray-med)',
    color: 'var(--trashie-ui-faded-black-100-b)',
    border: 'none',
    boxShadow: 'none',
    transition: 'background 0.2s, color 0.2s',
    '& .MuiTab-iconWrapper': {
      height: '1.5rem',
      width: '1.5rem',
      marginRight: 0,
      display: 'flex',
      alignItems: 'center',
    },
    '&.Mui-selected': {
      background: 'var(--trashie-primary-code-blue)',
      color: 'var(--ui-crisp-white)',
      fontWeight: 700,
      boxShadow: '0 2px 8px 0 rgba(36, 83, 227, 0.10)',
    },
    '&:hover, &.Mui-focusVisible': {
      background: 'var(--trashie-ui-gray-light)',
      color: 'var(--trashie-ui-blue-pastille)',
      '@media (max-width: 1020px)': {
        background: 'var(--trashie-primary-code-blue)',
        color: 'var(--ui-crisp-white)',
      },
    },

    '& img': {
      // makes svg black
      filter: 'brightness(0) saturate(100%)',
      height: '1.125rem',
      width: '1.125rem',
    },

  },
);

export default StyledCategoryTab;
